import React from 'react';
import { judgeAuthority } from '@/utils/Auth';
import { Redirect } from 'umi';

/** 基础布局 */
const BasicLayout: React.FC<any> = props => {
  const to = props?.location?.pathname;
  const hasAuth = judgeAuthority(to);
  return <div>{hasAuth ? props.children : <Redirect to="/login" />}</div>;
};

export default BasicLayout;
